import { gate } from 'hub-http/gates';
// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const TRI_TEMPORARY_DISCOUNT = gate('TRI::TemporaryDiscount');
export const UBX_CREDIT_ESTIMATION = gate('UBX:CreditEstimation');
export const PPIA_SALESBOT = gate('PPIA:SalesBot');
export const REVOS_RENAME = gate('Commerce:RevOSRename');
export const PPIA_DYNAMIC_BANNERS = gate('PPFE:DynamicBanners');